import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State, store } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { Organizations } from "@App/types/enums";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const useOrganizationParameters = () => {
  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();
  const { chooseOrganization } = bindActionCreators(actionCreators, dispatch);

  const organizationQuery = searchParams.get("organization");

  const organization = useSelector((state: State) => state.orders.organization);

  useEffect(() => {
    if (organizationQuery && !Object.values(Organizations).includes(parseInt(organizationQuery))) {
      return;
    }

    // get service from api if not in state
    if (organizationQuery && (!organization || organization.id !== parseInt(organizationQuery))) {
      // hack until new checkout is ready
      let newOrganization = organization;
      newOrganization.id = parseInt(organizationQuery);
      chooseOrganization(newOrganization);
    }
  }, [organizationQuery]);

  const organizationQueryParams = (): Record<string, string> => {
    return {
      // add brand if existing
      ...(store.getState().orders.organization && {
        organization: store.getState().orders.organization.id.toString(),
      }),
    };
  };

  return { organizationQueryParams };
};
